import { balanceUsd, useWallet } from './useWallet';
import { useCards, useAllCardBalances } from './useCards';
import { useIncptAsset } from './useIncptAsset';
import { useStaking } from './useStaking';
import { INCPT_COIN_ID, STAKING_BALANCE_ID, useUiStore } from '../store/ui';

/**
 * Grand total on the home screen: on-chain wallet + unfrozen cards + staking +
 * off-chain INCPT (reference price). A coin / staking slice hidden with the eye
 * on its own screen is left out — same key (`USDT-trx`, `INCPT`, `STAKING`, …).
 */
export function useTotalBalance() {
  const { balances, loading: walletLoading } = useWallet();
  const hidden = useUiStore((s) => s.coinBalanceHidden);
  const { cards, loading: cardsLoading } = useCards();
  const cardBalances = useAllCardBalances(cards);
  const incpt = useIncptAsset();
  const { summary, loading: stakingLoading } = useStaking();

  const walletUsd = balances.reduce((sum, b) => {
    if (hidden[`${b.token}-${b.chain}`]) return sum;
    return sum + balanceUsd(b);
  }, 0);

  const cardsUsd = cards.reduce((sum, c) => {
    if (c.status === 'frozen') return sum;
    return sum + (cardBalances[c.id] || 0);
  }, 0);

  const stakingUsd = hidden[STAKING_BALANCE_ID] ? 0 : summary.total;
  const incptUsd = hidden[INCPT_COIN_ID] ? 0 : incpt.usd;

  return {
    totalUsd: walletUsd + cardsUsd + stakingUsd + incptUsd,
    walletUsd,
    cardsUsd,
    stakingUsd,
    incptUsd,
    loading: walletLoading || cardsLoading || stakingLoading,
  };
}
